module.exports = __webpack_public_path__ + "img/logo-color.1e54d3a8.svg";